export const STATS_HEADER = 'STATS_HEADER';
export const STATS_HEADER_ERROR = 'STATS_HEADER_ERROR';
export const IS_STATS_LOADING = 'IS_STATS_LOADING';

export const STATS_ACTIVITIES = 'STATS_ACTIVITIES';
export const STATS_ACTIVITIES_ERROR = 'STATS_ACTIVITIES_ERROR';
export const IS_STATS_ACTIVITIES_LOADING = 'IS_STATS_ACTIVITIES_LOADING';
